module.exports = __webpack_public_path__ + "img/vodafone.d5aeae4f.jpg";